import './Spinner.css';

const Spinner = () => {
	return <div className="spinner-border" role="status" />;
};

export default Spinner;
